import { useState } from "react";
import { createPortal } from "react-dom";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "@/lib/api";

export function KillSwitchModal({ open, onClose, onDone }) {
  const [closePositions, setClosePositions] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!open) return null;
  const activate = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/kill-switch", { activate: true, close_positions: closePositions });
      toast.error(`KILL SWITCH ACTIVATED · ${data.canceled_orders} orders canceled · ${data.closed_positions} positions closed`);
      onDone?.(); onClose();
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="kill-switch-modal">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <div className="relative w-full max-w-md bg-[#181a20] border border-[#f6465d]/60 rounded p-5 fade-in">
        <div className="flex items-center gap-2 text-[#f6465d]"><AlertTriangle size={18} /><h2 className="font-display font-bold text-base">GLOBAL KILL SWITCH</h2></div>
        <p className="text-[#eaecef] text-sm mt-3">This will immediately:</p>
        <ul className="text-[#848e9c] text-xs mt-2 space-y-1 list-disc pl-5">
          <li>Stop the trading engine and block all new orders</li>
          <li>Cancel pending orders and expire pending signals</li>
          <li>Disable automated execution until you reset</li>
          <li>Record a critical audit event and notify you</li>
        </ul>
        <label className="flex items-center gap-2 mt-4 text-xs text-[#eaecef] cursor-pointer">
          <input type="checkbox" checked={closePositions} onChange={(e) => setClosePositions(e.target.checked)} className="accent-[#f6465d]" data-testid="kill-switch-close-positions-checkbox" />
          Also close all open positions at market
        </label>
        <div className="flex justify-end gap-2 mt-5">
          <button onClick={onClose} className="btn-ghost rounded px-4 h-9 text-xs" data-testid="kill-switch-cancel-button">Cancel</button>
          <button onClick={activate} disabled={busy} className="btn-red rounded px-4 h-9 text-xs" data-testid="kill-switch-confirm-button">{busy ? "Activating…" : "ACTIVATE KILL SWITCH"}</button>
        </div>
      </div>
    </div>,
    document.body
  );
}
